import React, { useState, useEffect, useRef, useCallback } from 'react';
import './nav.css';
import { HiOutlineMenu, HiOutlineX } from 'react-icons/hi';
import { FiDownload } from 'react-icons/fi';
import Resume from '../../data/resume';
import Logo from '../../assets/logo.svg';

const navItems = [
  { id: 'home', label: 'Home', index: '00' },
  { id: 'about', label: 'About', index: '01' },
  { id: 'focus', label: 'Focus', index: '02' },
  { id: 'experience', label: 'Experience', index: '03' },
  { id: 'skills', label: 'Skills', index: '04' },
  { id: 'contact', label: 'Contact', index: '05' },
];

const Nav = () => {
  const [activeNav, setActiveNav] = useState('home');
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const panelRef = useRef(null);

  const handleScroll = useCallback(() => {
    setScrolled(window.scrollY > 24);

    const probe = window.scrollY + window.innerHeight * 0.32;
    let current = navItems[0].id;

    navItems.forEach(({ id }) => {
      const section = document.getElementById(id);
      if (section && probe >= section.offsetTop) current = id;
    });

    // Snap to the last section once the page is scrolled to the bottom.
    if (window.innerHeight + window.scrollY >= document.body.offsetHeight - 80) {
      current = navItems[navItems.length - 1].id;
    }

    setActiveNav(current);
  }, []);

  useEffect(() => {
    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [handleScroll]);

  useEffect(() => {
    if (!menuOpen) return undefined;

    const onPointerDown = (e) => {
      if (panelRef.current && !panelRef.current.contains(e.target)) setMenuOpen(false);
    };
    const onKeyDown = (e) => e.key === 'Escape' && setMenuOpen(false);

    document.addEventListener('mousedown', onPointerDown);
    document.addEventListener('keydown', onKeyDown);
    document.body.style.overflow = 'hidden';

    return () => {
      document.removeEventListener('mousedown', onPointerDown);
      document.removeEventListener('keydown', onKeyDown);
      document.body.style.overflow = '';
    };
  }, [menuOpen]);

  return (
    <>
      <header className={`site-nav ${scrolled ? 'is-scrolled' : ''}`}>
        <div className="site-nav__inner">
        <a href="#home" className="site-nav__brand" aria-label="Fantahun Fekadu — home">
          <img src={Logo} alt="" />
          <span className="site-nav__brand-text">
            fantahun<span className="text-gradient">.dev</span>
          </span>
        </a>

          <nav className="site-nav__links" aria-label="Primary">
            {navItems.slice(1).map((item) => (
              <a
                key={item.id}
                href={`#${item.id}`}
                className={activeNav === item.id ? 'is-active' : ''}
              >
                <span className="site-nav__index">{item.index}</span>
                {item.label}
              </a>
            ))}
          </nav>

          <div className="site-nav__actions">
            <a href={Resume} download className="btn site-nav__resume">
              <FiDownload />
              Résumé
            </a>

            <button
              type="button"
              className="site-nav__toggle"
              aria-label={menuOpen ? 'Close menu' : 'Open menu'}
              aria-expanded={menuOpen}
              onClick={() => setMenuOpen((open) => !open)}
            >
              {menuOpen ? <HiOutlineX /> : <HiOutlineMenu />}
            </button>
          </div>
        </div>
      </header>

      {/*
        The overlay MUST stay a sibling of <header>, never a child. Once the
        header is scrolled it gains `backdrop-filter`, which makes it the
        containing block for any `position: fixed` descendant — that would
        collapse this full-screen overlay down to the height of the nav bar.
      */}
      <div className={`site-nav__overlay ${menuOpen ? 'is-open' : ''}`} aria-hidden={!menuOpen}>
        <div className="site-nav__panel" ref={panelRef}>
          {navItems.map((item) => (
            <a
              key={item.id}
              href={`#${item.id}`}
              onClick={() => setMenuOpen(false)}
              className={activeNav === item.id ? 'is-active' : ''}
            >
              <span className="site-nav__index">{item.index}</span>
              {item.label}
            </a>
          ))}

          <a href={Resume} download className="btn btn-primary site-nav__panel-resume">
            <FiDownload />
            Download Résumé
          </a>
        </div>
      </div>
    </>
  );
};

export default Nav;
